module.exports = __webpack_public_path__ + "img/disc-image.104c87ca.png";